import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Delivery = () => {
  return (
    <div>
      <Navbar />

      <div className="container">
        <div style={{ maxWidth: '1000px', margin: '40px auto', padding: '20px' }}>
          <h1 style={{ marginBottom: '30px', color: '#FF0000', fontSize: '32px', fontWeight: '700' }}>
            🚚 Livraison
          </h1>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Zones de livraison
            </h2>
            <p style={{ marginBottom: '20px', color: '#666', lineHeight: '1.8' }}>
              Nous livrons partout en République Démocratique du Congo (RDC). Nos services de livraison couvrent toutes les provinces et villes principales.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', marginBottom: '10px' }}>🏙️</div>
                <h3 style={{ margin: 0, color: '#333' }}>Villes principales</h3>
                <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
                  Kinshasa, Lubumbashi, Mbuji-Mayi, Kananga, Kisangani
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', marginBottom: '10px' }}>🌍</div>
                <h3 style={{ margin: 0, color: '#333' }}>Toutes les provinces</h3>
                <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
                  Livraison disponible dans toutes les 26 provinces de la RDC
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', textAlign: 'center' }}>
                <div style={{ fontSize: '32px', marginBottom: '10px' }}>📍</div>
                <h3 style={{ margin: 0, color: '#333' }}>Zones rurales</h3>
                <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>
                  Livraison possible dans les zones rurales avec délais supplémentaires
                </p>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Délais de livraison
            </h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                  <div style={{ fontSize: '32px' }}>⏱️</div>
                  <div>
                    <h3 style={{ margin: 0, color: '#0c5460' }}>Délai standard</h3>
                    <p style={{ margin: '5px 0 0 0', color: '#0c5460', fontWeight: '600' }}>
                      15 à 30 jours ouvrables
                    </p>
                  </div>
                </div>
                <p style={{ margin: 0, color: '#0c5460', lineHeight: '1.8' }}>
                  Délai moyen pour la livraison en RDC depuis les plateformes internationales. Ce délai inclut le traitement, l'expédition internationale et la livraison locale.
                </p>
              </div>

              <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                  <div style={{ fontSize: '32px' }}>⚡</div>
                  <div>
                    <h3 style={{ margin: 0, color: '#856404' }}>Livraison express</h3>
                    <p style={{ margin: '5px 0 0 0', color: '#856404', fontWeight: '600' }}>
                      7 à 15 jours ouvrables (supplément)
                    </p>
                  </div>
                </div>
                <p style={{ margin: 0, color: '#856404', lineHeight: '1.8' }}>
                  Option disponible pour une livraison accélérée. Des frais supplémentaires s'appliquent. Contactez-nous pour plus d'informations.
                </p>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Processus de livraison
            </h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  1
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Expédition internationale</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Votre commande est expédiée depuis la plateforme internationale (Shein, Amazon, Alibaba, etc.) vers notre centre de transit.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  2
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Arrivée en RDC</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Votre commande arrive en RDC et est traitée par nos services douaniers et de logistique.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  3
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Préparation locale</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Votre commande est préparée pour la livraison locale et vous recevez un Tracking ID unique.
                  </p>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  backgroundColor: '#FF0000', 
                  color: 'white', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  flexShrink: 0
                }}>
                  4
                </div>
                <div>
                  <h3 style={{ marginBottom: '10px', color: '#333' }}>Livraison finale</h3>
                  <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                    Votre commande est livrée à l'adresse indiquée. Vous recevez une notification et pouvez suivre le livreur en temps réel.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Frais de livraison
            </h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ marginBottom: '15px', color: '#666', lineHeight: '1.8' }}>
                Les frais de livraison sont calculés en fonction de plusieurs facteurs :
              </p>
              <ul style={{ paddingLeft: '20px', color: '#666', lineHeight: '1.8', marginBottom: '15px' }}>
                <li>Le poids et les dimensions du produit</li>
                <li>La zone de livraison (ville principale ou zone rurale)</li>
                <li>La valeur du produit</li>
                <li>Les frais douaniers et de transit</li>
              </ul>
              <p style={{ margin: 0, color: '#666', lineHeight: '1.8' }}>
                <strong>Les frais de livraison sont inclus dans le prix total</strong> que vous verrez avant de confirmer votre commande. Aucun frais supplémentaire ne vous sera demandé à la livraison.
              </p>
            </div>
          </div>

          <div className="card" style={{ marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Suivi de livraison
            </h2>
            <p style={{ marginBottom: '15px', color: '#666', lineHeight: '1.8' }}>
              Une fois votre commande expédiée, vous recevez un <strong>Tracking ID unique</strong> qui vous permet de suivre votre colis en temps réel :
            </p>
            <ul style={{ paddingLeft: '20px', color: '#666', lineHeight: '1.8', marginBottom: '20px' }}>
              <li>Statut en temps réel de votre commande</li>
              <li>Localisation actuelle du colis</li>
              <li>Date estimée de livraison</li>
              <li>Historique complet des mouvements</li>
            </ul>
            <div style={{ padding: '15px', backgroundColor: '#d1ecf1', borderRadius: '8px', border: '1px solid #0c5460' }}>
              <p style={{ margin: 0, color: '#0c5460' }}>
                📱 Vous recevrez des notifications par email et SMS à chaque étape importante de la livraison.
              </p>
            </div>
          </div>

          <div className="card">
            <h2 style={{ marginBottom: '20px', color: '#333', fontSize: '24px' }}>
              Questions fréquentes
            </h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Puis-je modifier l'adresse de livraison après avoir passé commande ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Oui, vous pouvez modifier l'adresse de livraison tant que la commande n'a pas été expédiée. Contactez notre support client pour toute modification.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Que faire si je ne suis pas disponible au moment de la livraison ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Le livreur vous contactera par téléphone. Si vous n'êtes pas disponible, un nouveau rendez-vous sera programmé. Vous pouvez également désigner une personne de confiance pour réceptionner votre colis.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Les frais de livraison sont-ils inclus dans le prix affiché ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Oui, le prix total que vous voyez avant de confirmer votre commande inclut tous les frais : prix du produit, commission, et frais de livraison. Aucun frais supplémentaire ne vous sera demandé.
                </p>
              </div>

              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                <h3 style={{ marginBottom: '10px', color: '#333', fontSize: '18px' }}>
                  Que faire en cas de colis endommagé ?
                </h3>
                <p style={{ margin: 0, color: '#666' }}>
                  Si votre colis arrive endommagé, refusez la livraison et contactez immédiatement notre service client. Nous procéderons à un remplacement ou à un remboursement selon votre préférence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Delivery;





